import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

const defaultState = () => {
  return  { 
    signals: {},
    location: "",
    locations: [],
    company: "",
    firstName: "",
    lastName: "",
    preferedName: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    state: "",
    zip: "",
    q: {},
    avail: {
      start_date: new Date().toISOString().substr(0, 10),
      sun: "",
      mon: "",
      tue: "",
      wed: "",
      thu: "",
      fri: "",
      sat: "",
      overnight: false,
    },
    edu: {
      hs: {},
      co: {},
      ot: {},
    },
    work: {
      1: {},
      2: {},
      3: {},
    },
    ref: {
      1: {},
      2: {},
      3: {},
    },
    signature: "",
    date: "",
  }
}

export default new Vuex.Store({
  plugins: [createPersistedState()],

  // todo - figure this issue
  // Error in callback for watcher "function () { return this._data.$$state }": "Error: [vuex] do not mutate vuex store state outside mutation handlers."
  strict: process.env.NODE_ENV !== "production",

  state: {},

  mutations: {
    clearState(state) {
      Object.assign(state, defaultState())
    },
    setSignals(state, payload) {
      state.signals = payload.signals;
    },
    setLocation(state, payload) {
      state.location = payload.location;
    },
    setLocations(state, payload) {
      state.locations = payload.locations;
    },
    setCompany(state, payload) {
      state.company = payload.company;
    },
    setFirstName(state, payload) {
      state.firstName = payload.firstName;
    },
    setLastName(state, payload) {
      state.lastName = payload.lastName;
    },
    setPreferedName(state, payload) {
      state.preferedName = payload.preferedName;
    },
    setEmail(state, payload) {
      state.email = payload.email;
    },
    setPhone(state, payload) {
      state.phone = payload.phone;
    },
    setAddress(state, payload) {
      state.address = payload.address;
    },
    setCity(state, payload) {
      state.city = payload.city;
    },
    setState(state, payload) {
      state.state = payload.state;
    },
    setZip(state, payload) {
      state.zip = payload.zip;
    },
    setQ(state, payload) {
      state.q = payload.q;
    },
    // P2
    setAvail(state, payload) {
      state.avail = payload.avail;
    },
    // P3
    setEdu(state, payload) {
      state.edu = payload.edu;
    },
    setWork(state, payload) {
      state.work = payload.work;
    },
    setRef(state, payload) {
      state.ref = payload.ref;
    },
    setSignature(state, payload) {
      state.signature = payload.signature;
    },
    setDate(state, payload) {
      state.date = payload.date;
    },
  },

  getters: {
    getLocations(state) {
      return state.locations;
    }
  },

  actions: {
    resetState(context) {
      context.commit('clearState')
    }
  },

  modules: {},
});
